var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"p-role-permission"},[(!(_vm.$route.name.match(/-chart/) || _vm.$route.name.match(/-editor/)))?_c('div',{staticClass:"row margin-bottom-medium"},[_c('div',{staticClass:"col-xs-12"},[_c('h1',{staticClass:"st-headline st-headline--1"},[_vm._v(_vm._s(_vm.title))])])]):_vm._e(),_vm._v(" "),_c('router-view')],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-56949b5c","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/p-role-permission.vue
// module id = null
// module chunks = 